export enum CUTSOM_FIELD_TYPES {
  TEXT = 'Text',
  DATE = 'Date',
  MULTI_SELECTION = 'MultiSelection',
  SINGLE_SELECTION = 'SingleSelection',
  LOCAL_TEXT = 'LocalText'
}

export enum CONTRACT_DEFAULT_FIELD {
  START_DATE_ID = 'CONTRACT_START_DATE',
  END_DATE_ID = 'CONTRACT_END_DATE'
}

export class CustomField {
  public Id: string;
  public Label: string;
  public Type: CUTSOM_FIELD_TYPES;
  public SelectItems: string[]; // SelectItems are not available for issued contracts customfields
  public DefaultValue: any; // can be string or string[]
  constructor(field?: any) {
    if (field) {
      this.Id = field.Id;
      this.Label = field.Label;
      this.Type = field.Type;
      this.SelectItems = field.SelectItems;
      this.DefaultValue = field.DefaultValue;
    }
  }
}

export class SmartContractTemplateModel implements ISmartContractModel {
  public CreatedBy: string;
  public CreatedOn: string;
  public DefaultEndDate: string;
  public DefaultStartDate: string;
  public EntityType: string;
  public InstanceId: string;
  public IsActive: boolean;
  public LastEditedBy: string;
  public LastEditedOn: string;
  public Name: string;
  public NumberOfContracts: number;
  public UserIdenedi: string;
  public CustomFields: CustomField[] = [];

  constructor(contract?: any) {
    if (contract) {
      this.CreatedBy = contract.CreatedBy;
      this.CreatedOn = contract.CreatedOn;
      this.DefaultEndDate = contract.DefaultEndDate;
      this.DefaultStartDate = contract.DefaultStartDate;
      this.EntityType = contract.EntityType;
      this.InstanceId = contract.InstanceId;
      this.IsActive = contract.IsActive;
      this.LastEditedBy = contract.LastEditedBy;
      this.LastEditedOn = contract.LastEditedOn;
      this.Name = contract.Name;
      this.NumberOfContracts = contract.NumberOfContracts;
      this.UserIdenedi = contract.UserIdenedi;
      this.setCustomFields(contract.CustomFields);
    }
  }

  setCustomFields(customFields: any[]) {
    if (!customFields || customFields.length === 0) {
      return;
    }
    for (const field of customFields) {
      if (!this.CustomFields) {
        this.CustomFields = [];
      }
      this.CustomFields.push(new CustomField(field));
    }
  }

  getTemplateId() {
    return this.InstanceId;
  }

  getStartDate() {
    return this.DefaultStartDate;
  }

  getEndDate() {
    return this.DefaultEndDate;
  }

  isIssuedContract() {
    return false;
  }
}

interface ISmartContractModel {
  getTemplateId();

  getStartDate();

  getEndDate();

  isIssuedContract();
}

export class SmartContractFile {
  public ContentType: string;
  public DownloadUrl = '';
  public FileName: string;
  public FileSize: number;
  public Id: string;
  public FileData: any;

  constructor(file?: any) {
    if (!file) {
      return;
    }
    this.ContentType = file.ContentType;
    this.DownloadUrl = file.DownloadUrl;
    this.FileName = file.FileName;
    this.FileSize = file.FileSize;
    this.Id = file.Id;
  }
}

export class SmartContractIssuedModel implements ISmartContractModel {
  public AttachedFiles: SmartContractFile[] = [];
  public ContractTemplateId: string;
  public CurrentStatus: string;
  public CustomFields: CustomField[] = [];
  public DaysFromEndDate: number;
  public DaysToStartDate: number;
  public EndDate: string;
  public EntityType: string;
  public GroupIdenedi: string;
  public InstanceId: string;
  public IsActive: boolean;
  public IssuedToName: string;
  public IssuedToTitle: string;
  public LastActivityOn: string;
  public MemberIdenedi: string;
  public MemberIdenedi_Details: any;
  public Name: string;
  public StartDate: string;
  public TemporalStatus: string;
  public UserIdenedi: string;

  constructor(model?: any) {
    this.ContractTemplateId = model.ContractTemplateId;
    this.CurrentStatus = model.CurrentStatus;
    this.DaysFromEndDate = model.DaysFromEndDate;
    this.DaysToStartDate = model.DaysFromEndDate;
    this.EndDate = model.EndDate;
    this.EntityType = model.EntityType;
    this.GroupIdenedi = model.GroupIdenedi;
    this.InstanceId = model.InstanceId;
    this.IsActive = model.IsActive;
    this.IssuedToName = model.IssuedToName;
    this.IssuedToTitle = model.IssuedToTitle;
    this.LastActivityOn = model.LastActivityOn;
    this.MemberIdenedi = model.MemberIdenedi;
    this.MemberIdenedi_Details = model.MemberIdenedi_Details;
    this.Name = model.Name;
    this.StartDate = model.StartDate;
    this.TemporalStatus = model.TemporalStatus;
    this.UserIdenedi = model.UserIdenedi;
    this.setAttachedFiles(model.AttachedFiles);
    this.setCustomFields(model.CustomFields);
  }

  setAttachedFiles(files: any[]) {
    if (!files || files.length === 0) {
      return;
    }
    for (const f of files) {
      if (!this.AttachedFiles) {
        this.AttachedFiles = [];
      }
      this.AttachedFiles.push(new SmartContractFile(f));
    }
  }

  setCustomFields(customFields: any[]) {
    if (!customFields || customFields.length === 0) {
      return;
    }
    for (const f of customFields) {
      if (!this.CustomFields) {
        this.CustomFields = [];
      }
      const newField = new CustomField(f);

      newField.DefaultValue = f.Value;

      if (newField.Type === CUTSOM_FIELD_TYPES.SINGLE_SELECTION || newField.Type === CUTSOM_FIELD_TYPES.MULTI_SELECTION) {
        if (!newField.DefaultValue) {
          newField.DefaultValue = [];
        } else {
          newField.SelectItems = newField.DefaultValue;
        }
      }

      this.CustomFields.push(newField);
    }
  }

  isDirectSharedContract() {
    return !this.MemberIdenedi || this.MemberIdenedi === '';
  }

  getTemplateId() {
    return this.ContractTemplateId;
  }

  getStartDate() {
    return this.StartDate;
  }

  getEndDate() {
    return this.EndDate;
  }

  isIssuedContract() {
    return true;
  }
}
